// removed by extract-text-webpack-plugin
module.exports = {"content":"c-ShippingCountry__content"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ShippingCountry/ShippingCountry.scss
// module id = 1127
// module chunks = 0